import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactHelpBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "contact_Help_Black",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	style: { enableBackground: "new 0 0 16 16" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:none;}\n	.st1{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12411",
			className: "st0",
			d: "M-4-4h24v24H-4V-4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12413",
			className: "st1",
			d: "M8,9.2V9c0-0.7,0.4-1.3,1-1.6c0.6-0.3,1-0.9,1-1.6c0-1.1-0.9-2-2-2s-2,0.9-2,2"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12414",
			className: "st1",
			d: "M8,12c-0.1,0-0.2,0.1-0.2,0.3c0,0.1,0.1,0.2,0.3,0.2c0.1,0,0.2-0.1,0.2-0.2 C8.3,12.1,8.1,12,8,12C8,12,8,12,8,12"
		})
	]
});
export default SvgContactHelpBlack;
